export default __webpack_public_path__ + "static/char-s-04-en-21aaf2e49f185a9edd3d16cd38eb20c8.png";